import React from 'react';
import { logger } from '../utils/logger';
import { captureError } from '../utils/sentry';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * React 渲染错误边界：捕获子树渲染异常，上报到后端日志与 Sentry，并展示兜底 UI。
 */
export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    // 后端记录完整上下文（含组件栈）；Sentry 单独以 exception 上报（避免经 logger 重复上报）。
    logger.error(
      error.message || 'react render error',
      { stack: error.stack, componentStack: info.componentStack },
      { sentry: false },
    );
    captureError(error, { componentStack: info.componentStack });
  }

  private handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 24, fontFamily: 'var(--font-family-ui)' }}>
          <h2>页面出错了</h2>
          <p>已记录该问题。你可以尝试刷新页面。</p>
          <button onClick={this.handleReload} style={{ marginTop: 12, padding: '6px 16px', cursor: 'pointer' }}>
            刷新页面
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
